// extracted by mini-css-extract-plugin
export var banner = "_rw-0";
export var settingRow = "_rw-2";
export var titleIcon = "_rw-1";